<template>
  <div>
    <data-list
      :payload="listPayloadObj"
      :headers="headers"
      v-model="pagination"
      :total="total"
      :pagination="pagination"
      class="pa-2"
      @setProperty="listOrder"
      >
    </data-list>
    <v-dialog scrollable v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition" persistent>
      <v-card tile>
        <v-card-title class="pa-2 ma-0" style="background: #000000;color: white">
          <h5 :style="$vuetify.theme.dark ? 'color: #dacdcd' : ''">{{ properties._id ? $t('message.props.updateProps') : $t('message.props.addProps') }}</h5>
          <v-spacer></v-spacer>
          <v-btn icon title="Close" :color="$vuetify.theme.dark ? '#dacdcd' : 'white'" @click="closeDialogHandler()">
           <v-icon>mdi-close-circle</v-icon>
          </v-btn>
       </v-card-title>
        <v-card-text class="pa-1">
          <property
              :payload="payload"
              :properties="properties"
              :token="accessToken"
              @update="onSuccessHandler"
              @change="updatePropertyObj"
              @closeForm="closeDialogHandler"
              v-if="dialog"
              >
          </property>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { checklistApi } from '@/plugins/checklist_api'
import { listOfFormTypes } from '@/utils/checklistutils/support_list'
export default {
  data () {
    return {
      total: 0,
      listPayloadObj: {
        isHeader: true,
        isHideAdd: false,
        selection: [],
        showSelect: true,
        headers: [],
        list: [],
        editProp: 'name',
        isAddnewAsMenu: true,
        addMenuActions: [],
        editHandler: this.getSingleRecordHandler,
        showSettingsBack: true,
        loading: true,
        isChecklist: true
      },
      dialog: false,
      pagination: !this.$formatter.isEmptyObject(this.$store.state.PROPS_INDEX) ? this.$store.state.PROPS_INDEX : { sortBy: ['name'], itemsPerPage: 25, sortDesc: [false], search: '' },
      MODULE: 'properties',
      payload: {
        from: 'properties',
        propid: 0
      },
      listOfFormTypes: [
        { text: 'Textfield', value: 1 },
        { text: 'Textarea', value: 2 },
        { text: 'Checkbox', value: 3 },
        { text: 'Radio', value: 4 },
        { text: 'Select', value: 5 },
        { text: 'Date', value: 6 },
        { text: 'Time', value: 7 },
        { text: 'Switch', value: 8 },
        { text: 'File', value: 9 },
        { text: 'Component', value: 10 },
        { text: 'Divider', value: 11 },
        { text: 'Grid', value: 12 },
        { text: 'Signature', value: 13 }
      ],
      properties: { _id: null, is_active: true, favourite: true },
      accessToken: process.env.VUE_APP_CHECKLIST_ACCESS_TOKEN,
      apiHeaders: { headers: { 'X-AccessToken': process.env.VUE_APP_CHECKLIST_ACCESS_TOKEN } },
      fieldTypes: listOfFormTypes,
      openDialog: false
    }
  },
  components: {
    'data-list': () => import('@/components/DataList'),
    property: () => import('@/components/Checklist/property/Index')
  },
  computed: {
    ...mapGetters(['listOfModules', 'getPageLoader', 'userDetails']),
    headers () {
      return [
        {
          text: this.$t('message.props.name'),
          value: 'name',
          isRoute: true,
          isModal: true,
          dbRef: 'Name',
          width: '30%'
        }, {
          text: this.$t('message.props.label'),
          value: 'label',
          sortable: true,
          dbRef: 'Label',
          width: '20%'
        }, {
          text: this.$t('message.props.type'),
          value: 'type',
          sortable: false,
          dbRef: 'Type',
          width: '20%'
        }, {
          text: this.$t('message.props.placeholder'),
          value: 'placeholder',
          sortable: true,
          dbRef: 'Placeholder',
          width: '20%'
        }
      ]
    }
  },
  watch: {
    pagination: {
      handler () {
        this.getListHandler()
      },
      deep: true
    }
  },
  mounted () {
    const text = this.$t('message.common.deleteSuccess')
    this.$eventBus.$on('deleteItems', (data) => {
      if (data.module === this.MODULE) {
        const payload = { ids: data.ids, url: `${this.MODULE}/delete_multiple`, module: this.MODULE, fromCheckList: true }
        this.$store.commit('showDeleteDialog', payload)
      }
    })
    this.$eventBus.$on('deleteSuccess', (data) => {
      if (data === this.MODULE) {
        this.listPayloadObj.selection = []
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
        this.$store.commit('hideDialog')
        this.getListHandler()
      }
    })
    this.$root.$on('getListHandler', () => {
      setTimeout(() => {
        this.getListHandler()
      }, 500)
    })
    this.fieldTypes.forEach((record) => {
      record.isShow = true
      record.label = record.text
    })
    this.listPayloadObj.addMenuActions = this.fieldTypes
  },
  methods: {
    getListHandler () {
      this.listPayloadObj.module = this.MODULE
      const queryFields = this.$formatter.cloneVariable(this.headers)
      queryFields.pop()
      let { page, sortBy, sortDesc, search, itemsPerPage } = this.$formatter.cloneVariable(this.pagination)
      const result = queryFields.find(x => x.value === sortBy[0])
      if (result) sortBy = result.dbRef
      sortDesc = sortDesc[0]
      const pageVal = page || 1
      const query = [{
        $match: {
          $or: [
            { Name: { $regex: `${search}`, $options: 'i' } },
            { Label: { $regex: `${search}`, $options: 'i' } },
            { Type: { $regex: `${search}`, $options: 'i' } },
            { Placeholder: { $regex: `${search}`, $options: 'i' } },
            { Is_Active: { $regex: `${search}`, $options: 'i' } }
          ]
        }
      }, { $skip: ((pageVal - 1) * itemsPerPage) },
      { $limit: itemsPerPage },
      { $sort: { [sortBy]: sortDesc ? -1 : 1 } }
      ]
      if (!search) query.splice(0, 1)
      this.listPayloadObj.loading = true
      this.listPayloadObj.headers = this.headers
      checklistApi.post(`${this.MODULE}/query`, query, this.apiHeaders).then((response) => {
        const countQuery = [{ $count: 'count' }]
        if (response.data.length > 0) {
          if (search) {
            countQuery.splice(0, 0, {
              $match: {
                $or: [
                  { Name: { $regex: `${search}`, $options: 'i' } },
                  { Label: { $regex: `${search}`, $options: 'i' } },
                  { Type: { $regex: `${search}`, $options: 'i' } },
                  { Placeholder: { $regex: `${search}`, $options: 'i' } },
                  { Is_Active: { $regex: `${search}`, $options: 'i' } }
                ]
              }
            })
          }
          checklistApi.post(`${this.MODULE}/query`, countQuery, this.apiHeaders).then(countResult => {
            this.total = countResult.data.length > 0 ? countResult.data[0].count : 0
          }).finally(() => {
            const data = response.data
            data.forEach(element => {
              element.id = element._id
              const resultType = this.listOfFormTypes.find(x => x.value === element.type)
              element.type = resultType ? resultType.text : ''
            })
            this.listPayloadObj.list = data
            this.listPayloadObj.loading = false
          })
        } else {
          this.listPayloadObj.list = []
          this.listPayloadObj.loading = false
        }
      }).finally(() => {
        this.listPayloadObj.loading = false
      })
    },
    onSuccessHandler (payload) {
      if (payload.status === 'success') {
        const text = payload.data && payload.action === 'add' ? this.$t('message.common.addedSucess') : this.$t('message.common.updatedSuccess')
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
        if (payload.type === 'UPDATE_CLOSE') this.closeDialogHandler()
        else this.properties._id = payload.data.data._id
        this.getListHandler()
      } else {
        this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: payload.data.response.data })
      }
    },
    closeDialogHandler () {
      this.payload = { from: 'properties', propid: 0 }
      this.properties = { _id: null, is_active: true, favourite: true }
      this.dialog = false
    },
    updatePropertyObj (model) {
      this.properties = model
    },
    getSingleRecordHandler (id) {
      this.properties._id = id
      this.dialog = true
    },
    listOrder (item) {
      this.properties = { _id: null, is_active: true, favourite: true }
      this.properties.type = item.value
      this.dialog = true
    }
  },
  beforeDestroy () {
    this.$eventBus.$off('deleteSuccess')
    this.$root.$off('getListHandler')
  }
}
</script>
<style scoped>
.hide .v-dialog {
  overflow-x: hidden !important;
}
</style>
